// Name for common metrics across pages for AIM portal.
export const APP_METRICS = 'AppPortalMetrics';

export const MetricDimensionNames = Object.freeze({
  PAGE_NAME_DIMENSION: 'pageName',
  USER_ALIAS_DIMENSION: 'userAlias',
  INTERACTION_NAME_DIMENSION: 'interactionName',
  INTERACTION_TYPE_DIMENSION: 'interactionType'
});
